export default "__VITE_ASSET__uDeTpPPw__"